import '@rbx/ui';
import React, { ComponentPropsWithoutRef } from 'react';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';
import useMarkdownListStyles from './MarkdownList.styles';

type ListItemProps = ComponentPropsWithoutRef<'ol'>;

export default function MarkdownOrderedList({ children, ...otherProps }: ListItemProps) {
  const { enableEngineReferenceRevamp } = useAppConfig();
  const {
    classes: { listContainer, orderedList },

    cx,
  } = useMarkdownListStyles({ enableEngineReferenceRevamp: !!enableEngineReferenceRevamp });

  return (
    <ol {...otherProps} className={cx(listContainer, orderedList)}>
      {children}
    </ol>
  );
}
